import { Building, Webpage } from 'api/request';
import { SharePointBlobFiles } from 'components/FileTypes/Files.types';
import { Dispatch, SetStateAction } from 'react';
import { FieldValues, UseFormMethods } from 'react-hook-form';

export interface IStep {
  currentStep: number;
  nextStep: number | false;
}

export interface ILearningWizardStep {
  label: string;
  name: string;
  noteTypeId?: number;
  description: string;
  type: FORMTYPES;
  selection: any[];
  placeHolder: string;
  defaultValue: { value: number; label: string } | null;
  required: boolean;
  step: number;
  nextStep: number | false;
  dependsOn: { name: string; value: string[] }[];
}

export type WizardStep = {
  key?: string;
  label: string;
  name: string;
  noteTypeId?: number;
  description: string;
  type: FORMTYPES;
  selection: { value: string; label: string }[];
  placeHolder: string;
  defaultValue: { value: string | Date; label: string | Date } | null;
  required: boolean | { required: string; maxLength: { value: number; message: string } };
  step: number;
  nextStep: number | false;
  dependsOn: ((param: any) => boolean)[];
  testId?: string;
  section: { label: string; description: string } | null;
  textBoxSize?: number;
};
export interface IWizardSteps<IWizardStep> {
  steps: IWizardStep[];
}

export enum FORMTYPES {
  Radio = 'radio',
  TextBox = 'textBox',
  Attachments = 'attachments',
  AsyncSelectInput = 'asyncSelectInput',
  ApprovalChain = 'approvalChain',
  JustificationNotes = 'justificationNotes',
  WarningNotification = 'warningNotification',
  Calendar = 'calendar',
  RichTextEditor = 'richTextEditor',
  SelectInput = 'selectInput',
  Section = 'section'
}

export enum DEPARTMENTS {
  CorporateApplications = 3,
  Branding = 4,
  Learning = 5,
  FacilitiesDesign = 6,
  CorporateWebsite = 7
}

export interface IConfig {
  step: IStep;
  setStep: Dispatch<SetStateAction<IStep>>;
  meQuery: any;
  attachmentExtensionsQuery: any;
  enums: any;
  sharePointFiles: SharePointBlobFiles[];
  form: UseFormMethods<FieldValues>;
  fdrBuildingOptions: Building[];
}

export enum LEARNING_PURPOSE {
  TrainingRequest = '22',
  GeneralConsult = '23',
  InternalProject = '24'
}

export enum FACILITIES_DESIGN_PURPOSE {
  BuildingShellTenantSite = '26',
  EnvironmentalSiteFaciltyMaps = '27',
  FeasibilityStudies = '28',
  NewEquipmentAndUtilities = '29',
  FurnitureInstallation = '30',
  AsBuiltUpdates = '31',
  BuildingInteriorMinorImprovements = '32'
}

export enum CA_PURPOSE {
  Hardware = '6',
  InfrastructureSoftware = '20',
  Infrastructure = '21',
  Applications = '3',
  InformationSecurity = '11',
  Documentation = '10',
  Evaluation = '25'
}

export enum CW_PURPOSE {
  Administrative = '33',
  CompanySupport = '34',
  ProductSupport = '35',
  Feature = '36'
}

export interface ALRequestSubmissionPayload {
  requestId?: number | null;
  departmentId: number;
  teamId: number;
  supervisorTeamId: number;
  projectName: string;
  projectPurposeId: number;
  projectTypeId: number;
  updateNotes: string;
  requestedImplementationDate: string | Date;
  dueDateReason: string;
  intendedUse: string;
  escalationJustification: string;
  escalationApproverTeamId: number;
  projectPurposeText: string;
  projectPurposeOtherText: string;
  requestUpdateCategoryId: number;
  businessImpactId: number;
  justificationNotes: JustificationNote[];
  approvers: Approver[];
  rowVersion?: string;
}

export interface JustificationNote {
  justificationNoteTypeId: number;
  noteText: string | null;
  requestId?: number | undefined;
  rowVersion?: string | undefined;
  justificationNoteId?: number;
}

export interface Approver {
  sequence?: number;
  reviewerId: number;
}

export enum ALREQUESTTYPE {
  TrainingRequest = '22',
  GeneralConsult = '23',
  InternalProject = '24'
}

export enum NewOrExistingValues {
  New = '1',
  Update = '2'
}
